import axiosClient from "../../network";

export default class sportsBannerService {
  static getSportsBannerData(payload) {
    return axiosClient
      .post("user/getSportsBanner", payload, {
        headers: {
          "domain-key": process.env.REACT_APP_DOMAIN_KEY
        }
      })
      .then(({ data, status }) => {
        return { data, status };
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
